/* global swal, _, angular*/

import './style.less';
import { sponsor } from '@prolaera/library';
import { deliveryMethods } from '@prolaera/library';
import { findIndex, get } from 'lodash';

export default function(
  $q,
  $log,
  $state,
  $stateParams,
  $rootScope,
  Swal,
  ApiClass,
  ProfileClass,
  Upload,
  ResolveClass
) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const profile_uid = $stateParams.employeeID || $stateParams.id;
  const manage = ResolveClass.isManageRoute();

  const { profile, company } = ProfileClass.profileComplete;

  const companyPreferences =
    company && 'preferences' in company && 'certificates' in company.preferences
      ? company.preferences.certificates
      : {};

  vm.sponsors = sponsor;

  function updateUploadStatus(pdf_uploaded, pdf) {
    return ApiClass.usersIdTypeTypeIdPatch(
      { id: profile_uid, type: 'certificates', type_id: $stateParams.certId, manage: false },
      { pdf, pdf_uploaded },
      {}
    );
  }

  function uploadFile(file, s3Policy) {
    return $q((resolve, reject) => {
      return Upload.upload({
        url: s3Policy.filePolicy.action,
        data: s3Policy.filePolicy.fields,
        file: file,
        method: 'POST',
        skipAuthorization: true
      })
        .then(
          function() {
            vm.pdfProgress = 'Uploaded';
            resolve('uploaded');
          },
          function(resp) {
            $log.error('Error status: ' + resp.status);
            throw new Error(`PDF UPLOADING ERROR ${$stateParams.id}`);
          },
          function(evt) {
            const pdfStaus = parseInt((100.0 * evt.loaded) / evt.total);
            vm.pdfProgress = `${pdfStaus}%`;
          }
        )
        .catch(error => reject(error));
    });
  }

  vm.uploadPdf = file => {
    if (!file) return;
    vm.pdfProgress = 'Uploading...';
    vm.formData.pdf_uploaded = false;
    vm.uploadBtn = true;

    ApiClass.companiesIdTypePut(
      { manage, id: ProfileClass.company_id, type: 'policies' },
      {
        profile_uid,
        policy: 'certificate',
        cert_id: $stateParams.certId,
        file_type: file.type,
        file_name: file.name
      }
    )
      .then(({ data: { item: s3Policy } }) => {
        vm.s3Policy = s3Policy;
        return uploadFile(file, s3Policy);
      })
      .then(() => updateUploadStatus(true, vm.s3Policy.link))
      .then(() => {
        vm.formData.pdf = `${vm.s3Policy.link}?time=${new Date().getTime()}`;
        vm.formData.pdf_uploaded = true;
        vm.uploadBtn = false;
        vm.uploaded = true;
        vm.fileToUpload = false;
        vm.certificatePreview = true;
      })
      .catch(error => {
        vm.uploadBtn = false;
        vm.uploaded = false;
        vm.formData.pdf_uploaded = false;
        $log.error(error);
        throw error;
      });
  };

  function validateSponsorInfo({ sponsors_types, sponsors }) {
    let valid = false;

    if (sponsors_types) {
      for (const sponsor in sponsors_types) {
        if (sponsors_types[sponsor]) valid = true;
      }
    }

    if (sponsors) {
      for (const sponsor in sponsors) {
        if (sponsor !== 'name' && sponsors[sponsor]) valid = true;
      }
    }

    return valid;
  }

  function validateFileUpload({ pdf_uploaded }) {
    let valid = !(!profile.admin && companyPreferences.requireDocumentUpload);

    if (pdf_uploaded) valid = true;

    return valid;
  }

  vm.submit = submit;

  function submit(formData) {
    formData.hours_basic = formData.formData.modifiedStates.reduce((obj, state) => {
      obj[state.reg_id] = state.hours;
      return obj;
    }, {});

    Object.keys(formData.sponsors).forEach(id => {
      if (!formData.sponsors[id] || formData.sponsors[id].length < 1) delete formData.sponsors[id];
    });

    formData.delivery_uid = parseInt(formData.delivery_uid);

    const params = {
      cert: formData.cert,
      date: new Date(formData.completionDate).toISOString(),
      delivery:
        deliveryMethods[
          findIndex(deliveryMethods, {
            key: vm.formData.delivery_uid
          })
        ].name,
      delivery_uid: formData.delivery_uid,
      hours: formData.hours,
      hours_basic: formData.hours_basic,
      location: formData.location,
      pdf: formData.pdf,
      pdf_uploaded: formData.pdf_uploaded,
      sponsor: formData.sponsors.name,
      sponsors: formData.sponsors || {},
      sponsors_types: formData.sponsors_types || {},
      temp: formData.temp
    };

    params.delivery_date = formData.startDate ? new Date(formData.startDate).toISOString() : null;

    if (!validateSponsorInfo(params))
      return Swal.alert('Hold Up!', 'Please enter sponsor information or select "None Provided".', 'info');
    if (!validateFileUpload(params)) return Swal.alert('Hold Up!', 'Please upload a copy of your certificate.', 'info');

    const swalMessage =
      companyPreferences.applyApprovedOnly && !profile.admin && !profile.team_leader
        ? 'Your certificate has been submitted for approval!'
        : 'Course information updated';

    if (formData.temp) {
      return tempStatus(formData);
    }

    vm.submitBtn = true;

    ApiClass.usersIdTypeTypeIdPatch(
      { id: profile_uid, type: 'certificates', type_id: $stateParams.certId, manage: false },
      params,
      {}
    )
      .then(() => {
        Swal.toast(swalMessage);
        vm.submitBtn = false;
        $rootScope.$back();
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }

  function tempStatus(formData) {
    return Swal.confirm(
      'Pending Certificate',
      'This certificate is pending. Have you completed this course and would like to add the credits to your account?',
      undefined,
      undefined,
      'No'
    )
      .then(() => {
        formData.temp = false;
        return submit(formData);
      })
      .catch(error => {
        if (error.dismiss === 'cancel') {
          delete formData.temp;
          return submit(formData);
        }
        throw error;
      });
  }

  vm.emailAddress = get(ProfileClass, 'profile_complete.company.preferences.certifications.emailAddress', false);

  vm.checkRoute = function(route) {
    return ResolveClass.isAllowedCompanyRoute(route);
  };

  function activate() {
    $log.debug('Users Certificate Edit Activated');

    vm.submitBtn = false;
    vm.loaded = false;
    vm.error = {};

    const qArr = [
      ApiClass.usersIdTypeTypeIdGet({
        id: profile_uid,
        type: 'certificates',
        type_id: $stateParams.certId,
        manage: false
      }),
      ApiClass.usersIdGet(
        { id: profile_uid },
        {},
        {
          queryParams: {
            'include:withchildren': true
          }
        }
      )
    ];

    $q.all(qArr)
      .then(([{ data: { item: cert } }, { data: { item: cert_profile } }]) => {
        vm.certProfile = ResolveClass.isAdminRoute() ? cert_profile : null;

        if (cert && cert.internal_pdf === true) $state.go('app.users.certificates', $stateParams);
        if (cert.delivery_uid) cert.delivery_uid = parseInt(cert.delivery_uid);
        if (!cert.hours) cert.hours = [{}];
        vm.deliveries = deliveryMethods;
        vm.formData = cert;
        vm.formData.completionDate =
          !cert.date || isNaN(new Date(cert.date).getTime())
            ? moment()
                .startOf('day')
                .toDate()
            : new Date(cert.date);
        vm.formData.startDate =
          !cert.delivery_date || isNaN(new Date(cert.delivery_date).getTime())
            ? undefined
            : new Date(cert.delivery_date);

        if (Object.prototype.toString.call(cert.sponsors) !== '[object Object]') vm.formData.sponsors = {};
        if (Object.prototype.toString.call(cert.sponsors_types) !== '[object Object]') vm.formData.sponsors_types = {};
        if (vm.formData.sponsor) vm.formData.sponsors.name = vm.formData.sponsor;

        if (vm.formData.delivery_uid === undefined && !_.isEmpty(vm.formData.delivery)) {
          const tempDelivery = deliveryMethods[findIndex(deliveryMethods, { name: vm.formData.delivery })];
          if (tempDelivery && tempDelivery.key) vm.formData.delivery_uid = tempDelivery.key;
        }

        vm.showPrepEdit = !!cert.hours.filter(({ prep }) => prep).length;

        vm.certificatePreview = angular.copy(!!vm.formData.pdf_uploaded);

        vm.resultsQueried = true;
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/certificates/edit/index.js